var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.error)?_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"width":"100%","height":"100%;"}}):_vm._e(),(_vm.error)?_c('div',{staticClass:"error"},[_c('div',{staticClass:"error-text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.error)}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }